export default __webpack_public_path__ + "static/media/logo.3de78833.png";